export default __webpack_public_path__ + "static/seo-f23cd4dc4c8dd7d4a1cb1c932afbf0ce.gif";